import { useThemeContext } from "../theme/ThemeContext";
import { Button } from "./shared";
import { overlayBackdrop } from "../theme/styles";

export function InactivityModal({ secondsLeft, onStillHere }) {
  const { SA, GLASS, tokens, TYPOGRAPHY, RADIUS } = useThemeContext();
  const mins     = Math.floor(secondsLeft / 60);
  const secs     = secondsLeft % 60;
  const countStr = mins > 0 ? `${mins}:${String(secs).padStart(2, "0")}` : `${secs}s`;
  const pct      = secondsLeft / 300;
  const urgent   = secondsLeft <= 60;

  return (
    <div style={{ ...overlayBackdrop,
      zIndex: 500, display: "flex", alignItems: "center", justifyContent: "center",
      padding: 24, fontFamily: "'HelveticaNeueStd','Barlow','Helvetica Neue',Arial,sans-serif",
      backdropFilter: "blur(6px)" }}>
      <div style={{ ...GLASS.modal,
        width: "100%", maxWidth: 360,
        border: `1px solid ${urgent ? tokens.dangerBorder : "rgba(255,255,255,0.11)"}`,
        borderTop: `2px solid ${urgent ? tokens.danger : "rgba(255,255,255,0.22)"}`,
        borderRadius: RADIUS.pill, padding: "32px 28px", textAlign: "center",
        boxShadow: urgent ? `inset 0 1px 0 rgba(255,255,255,0.13), 0 0 40px ${tokens.dangerBgGlow}` : "inset 0 1px 0 rgba(255,255,255,0.13), 0 24px 64px rgba(0,0,0,0.55)",
        transition: "border-color 0.5s, box-shadow 0.5s" }}>

        <div style={{ fontSize: 36, marginBottom: 16 }}>
          {urgent ? "⚠️" : "👋"}
        </div>
        <div style={{ fontSize: TYPOGRAPHY.header, fontWeight: 600, color: SA.white,
          letterSpacing: "-0.02em", marginBottom: 8 }}>
          Are you still there?
        </div>
        <div style={{ fontSize: TYPOGRAPHY.note, color: SA.silver, lineHeight: 1.6, marginBottom: 24 }}>
          The connection tool will sign you out due to inactivity.
        </div>

        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: urgent ? 44 : 38, fontWeight: 700,
            fontFamily: "'HelveticaNeueStd','Barlow','Helvetica Neue',Arial,sans-serif",
            color: urgent ? tokens.danger : SA.lightSilver,
            letterSpacing: "0.04em", transition: "color 0.5s" }}>
            {countStr}
          </div>
          <div style={{ height: 3, background: SA.borderGray, borderRadius: 2,
            marginTop: 10, overflow: "hidden" }}>
            <div style={{ height: "100%", borderRadius: 2,
              width: `${pct * 100}%`,
              background: urgent ? tokens.danger : SA.accent,
              transition: "width 1s linear, background 0.5s" }} />
          </div>
        </div>

        <Button variant="primary" fullWidth onClick={onStillHere}
          style={{ padding: "14px", borderRadius: 12,
            fontSize: TYPOGRAPHY.sub, fontWeight: 600,
            letterSpacing: "-0.01em", transition: "opacity 0.15s" }}
          onMouseEnter={e => e.currentTarget.style.opacity = "0.85"}
          onMouseLeave={e => e.currentTarget.style.opacity = "1"}>
          I'm still here
        </Button>
        <div style={{ fontSize: TYPOGRAPHY.caption, color: SA.borderGray, marginTop: 12 }}>
          Any action on this page will also keep you signed in
        </div>
      </div>
    </div>
  );
}
